export default __webpack_public_path__ + "static/media/logout.57906904.svg";